import React from "react";
import { Text } from "braid-design-system";
import type { FieldConfig, RenderField } from "./transactionScreenTypes";

type TransactionTotalsSectionProps = {
    visibleTotalFields: FieldConfig[];
    renderField: RenderField;
    computedTotals: { gross: string; netDiscountAmount: string; tax: string; net: string };
    headerData: Record<string, string>;
};

const TransactionTotalsSection: React.FC<TransactionTotalsSectionProps> = ({ visibleTotalFields, renderField, computedTotals, headerData }) => {
    const taxValue = String(headerData.tax ?? "").trim() === ""
        ? computedTotals.tax
        : headerData.tax;

    return (
        <section className="transaction-section">
            <div className="transaction-section-heading">
                <Text weight="strong">Totals</Text>
            </div>
            <div className="transaction-totals-grid">
                {visibleTotalFields.map((field) => {
                    if (field.key === "gross") {
                        return renderField(field, { value: computedTotals.gross, disabled: true });
                    }

                    if (field.key === "netDiscountAmount") {
                        return renderField(field, { value: headerData.netDiscountAmount || "0" });
                    }

                    if (field.key === "tax") {
                        return renderField(field, { value: taxValue });
                    }

                    if (field.key === "net") {
                        return renderField(field, { value: computedTotals.net, disabled: true });
                    }

                    return renderField(field);
                })}
            </div>
        </section>
    );
};

export default TransactionTotalsSection;
